// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1uXti","primaryBlue":"styles_primaryBlue__5V9sc","button":"styles_button__Pp1gU","text":"styles_text__6T5oq"};